import { render, staticRenderFns } from "./Imagens.vue?vue&type=template&id=266f0bef&scoped=true"
import script from "./Imagens.vue?vue&type=script&lang=js"
export * from "./Imagens.vue?vue&type=script&lang=js"
import style0 from "./Imagens.vue?vue&type=style&index=0&id=266f0bef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266f0bef",
  null
  
)

export default component.exports